export default __webpack_public_path__ + "static/media/bg_login_portal-client_grey.705a7141.svg";